<template>
    <div class="main-container">
        <div class="detail-header-buttons">
            <v-btn @click="back" style="width: auto !important" class="button-accept">
                <v-icon>mdi-chevron-left</v-icon>
                Вернуться к списку деятельности
            </v-btn>
            <div>
                <v-btn @click="goToEdit" class="button-action">
                    Редактировать
                </v-btn>
                <v-btn v-if="item.isRemovable" style="margin-left: 40px" @click="goToCreate" class=" button-accept">
                    + Добавить блок
                </v-btn>
            </div>

        </div>





        <div class="main-container" v-if="item.isRemovable">
            <div class="main-container-title-box" style="margin-bottom: 20px">
                <div class="table-title">
                    <span>
                        Список блоков
                    </span>
                </div>



            </div>
            <div class="table-container">


                <v-data-table :headers="tableHeaders" :items="blocks" item-key="id" :show-select="false"
                    :disable-pagination="true" :hide-default-footer="true">

                    <template v-slot:body="props">
                        <draggable :list="props.items" tag="tbody" @end="endDrag" :move="checkMove"
                            :style="moveItems ? 'pointer-events: none;' : ''">
                            <tr v-for="(item, index) in props.items" :key="index" @click="goToDetail(item)">
                                <td>
                                    <v-icon small style="cursor: pointer; margin-left: 8px"
                                        :disabled="moveItems ? true : false">
                                        mdi-menu
                                    </v-icon>
                                </td>
                                <td> {{ index + 1 }} </td>
                                <td>
                                    {{ item.title }}
                                </td>

                                <td>
                                    <div v-if="item.transition && item.transition.type == 'url'">
                                        Ссылка
                                    </div>
                                    <div
                                        v-else-if="item.transition && item.transition.type == 'deeplink' && item.transition.appSectionKey == 'events'">
                                        Событие
                                    </div>
                                    <div
                                        v-else-if="item.transition && item.transition.type == 'deeplink' && item.transition.appSectionKey != 'events'">
                                        Раздел
                                    </div>
                                    <div v-else-if="item.transition && item.transition.type == 'file'">
                                        Файл
                                    </div>
                                </td>



                            </tr>
                        </draggable>
                    </template>

                </v-data-table>


            </div>
            <v-divider></v-divider>
        </div>
        <div class="main-container-info-box" v-else>
            <div class="info-block" v-if="item.name">
                <div class="info-block-title">
                    Название
                </div>
                <div class="info-block-text">
                    {{ item.name }}
                </div>
            </div>
            <div class="info-block" v-if="item.text">
                <div class="info-block-title">
                    Основной текст
                </div>
                <div class="info-block-text">
                    {{ item.text }}
                </div>
            </div>
            <div class="info-block" v-if="item.files && item.files.length > 0">
                <div class="info-block-title">
                    Вложенные файлы
                </div>
                <div class="info-block-text">
                    <div v-for="(i, index) in item.files" :key="index">
                        <v-icon> mdi-file-pdf-box </v-icon>
                        <a style="margin-left:8px" target="_blank" :href="i.file">{{ i.name }}</a>
                    </div>
                </div>
            </div>
            <div>
                <div class="table-title">
                    Изображение
                    <v-icon @mouseover="openInfoImg($event)" @mouseleave="showInfoImg = false" color="#E0E0E0">
                        mdi-information
                    </v-icon>

                </div>
                <v-menu v-model="showInfoImg" :position-x="xImg" :position-y="yImg" absolute offset-y>
                    <v-card>
                        <div class="menu-container">
                            <div class="menu-container-text">
                                Нажмите на изображение, чтобы увидеть его в полном размере
                            </div>
                        </div>

                    </v-card>
                </v-menu>

            </div>

            <div>
                <v-simple-table v-if="item">
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th style="padding-left: 24px" class="text-left">
                                    Формат
                                </th>
                                <th class="text-left">
                                    Место отображенния
                                </th>
                                <th class="text-left">
                                    Для смартфонов
                                </th>
                                <th class="text-left">
                                    Для планшетов
                                </th>
                            </tr>
                        </thead>
                        <tbody>

                            <tr style="height: 60px;">
                                <td style="padding-left: 24px" class="text-left">Иконка</td>
                                <td class="text-left">Изображение папки раздела</td>
                                <td class="text-left">
                                    <img @click="openDialogImg(item.smartphoneImage)" v-if="item.smartphoneImage"
                                        class="table-img" :src="item.smartphoneImage">
                                </td>
                                <td class="text-left">
                                    <img @click="openDialogImg(item.tabletImage)" v-if="item.tabletImage" class="table-img"
                                        :src="item.tabletImage">
                                </td>
                            </tr>




                        </tbody>
                    </template>
                </v-simple-table>

                <DialogImage v-model="dialogImg" :src="previewImage" />
                <v-divider></v-divider>
            </div>


        </div>



    </div>
</template>
<script>

import draggable from "vuedraggable";
export default {
    components: {
        draggable
    },
    data: () => ({


        item: {},
        blocks: [],
        showInfoImg: false,
        xImg: null,
        yImg: null,
        imageWidth: 0,
        previewImage: null,
        dialogImg: false,
        moveItems: false,
        selectedDrag: '',
        tableHeaders: [
            {
                text: '',
                sortable: false
            },
            {
                text: 'Порядок отображения',
                value: '',
                sortable: false
            },

            {
                text: 'Название',
                sortable: false,
                value: 'title',
            },
            {
                text: 'Вид перехода',
                sortable: false,
                value: 'transition',

            },


        ],
        newIndexList: [],

    }),
    methods: {
        openDialogImg(src) {
            this.previewImage = src
            this.dialogImg = true
        },
        openInfoImg(e) {
            e.preventDefault()
            this.xImg = e.clientX + 10
            this.yImg = e.clientY + 10
            this.showInfoImg = true

        },

        back() {
            this.$router.push({ name: 'CouncilActivity', params: { selectedTicker: 2 } })

        },
        goToEdit() {
            this.$router.push({ name: 'EditFolderOther', params: { id: this.$route.params.id } })

        },
        goToCreate() {
            this.$router.push({ name: 'CreateFolderBlockOther', params: { id: this.$route.params.id } })

        },
        goToDetail(item) {
            this.$router.push({ name: 'EditFolderBlockOther', params: { id: this.$route.params.id, idBlock: item.id } })
        },



        getFolder() {
            this.$axios.get(this.$store.getters.apiAdminPanelV2 + '/activity/other/folder', {
                headers: {
                    'authorization': this.$store.getters.adminPanelHeaderAuth
                },
                params: {
                    folderId: this.$route.params.id
                }
            })
                .then(res => {
                    this.item = res.data
                    this.blocks = res.data.blocks

                })
                .catch(err => {
                    this.$store.commit('errorSet', true)
                    this.$store.commit('errorTextSet', err)
                })

        },
        endDrag(evt) {

            this.moveItems = true
            this.$axios.put(this.$store.getters.apiAdminPanelV2 + '/activity/other/folder/block/sort', {
                blockId: this.selectedDrag,
                index: evt.newIndex + 1

            }, {
                headers: {
                    'authorization': this.$store.getters.adminPanelHeaderAuth
                }
            })
                .then(() => {
                    this.getFolder()
                    this.moveItems = false


                })
                .catch(err => {
                    this.$store.commit('errorSet', true)
                    this.$store.commit('errorTextSet', err)
                })

        },
        checkMove(evt) {
            this.selectedDrag = evt.draggedContext.element.id
        },

    },
    created() {
        this.getFolder()
    },
}
</script>
<style lang="scss" scoped>
.main-container {
    .detail-header-buttons {
        box-sizing: border-box;
        padding: 40px 24px !important;
        display: flex;
        justify-content: space-between;
    }

    .main-container-title-box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 24px;

        .main-container-title-box-text {
            display: flex;
            align-items: center;

            span {
                font-size: 28px;
                font-weight: 400;
                margin-right: 20px;
            }

        }

    }

    .main-container-info-box {
        .table-title {
            font-size: 24px;
            font-weight: 600;
            margin: 0 24px;
        }

        .info-block {
            width: 50%;
            margin-bottom: 50px;

            .info-block-title {
                font-size: 24px;
                font-weight: 600;
            }

            .info-block-text {
                font-size: 18px;
                font-weight: 400;
            }
        }

        .table-img {
            cursor: pointer;
            height: 38px;
            object-fit: contain;
        }


    }
}

.main-container-info-box {
    .table-title {
        font-size: 24px;
        font-weight: 600;
        margin: 0 24px;
    }

    .info-block {
        width: 50%;
        margin: 0 24px;
        margin-bottom: 50px;

        .info-block-title {
            font-size: 24px;
            font-weight: 600;
        }

        .info-block-text {
            font-size: 18px;
            font-weight: 400;
        }
    }

    .table-img {
        cursor: pointer;
        height: 38px;
        object-fit: contain;
    }


}

.table-title {
    font-size: 24px;
    font-weight: 600;
}
</style>